export const addTokenToLink = (link: string, token: string): string => {
  if (!link) return ''

  const url = new URL(link.trim())
  url.searchParams.set('deep_link_value', token)

  return url.href
}
